/**
 * Testimonials data - Partner/Collaborator testimonials
 * Based on Bahraini market partnerships
 *
 * This data is extracted to support future migration to database/API.
 * The structure matches the expected format for InfiniteMovingCards component.
 */

export type Testimonial = {
	quote: string;
	name: string;
	title: string;
};

/**
 * Client testimonials for the collaborations carousel
 */
export const testimonials: Testimonial[] = [
	{
		quote:
			"Exceptional design work that perfectly captured our brand identity. The attention to detail was remarkable.",
		name: "Sarah Al-Khalifa",
		title: "Director of Facilities, Informa",
	},
	{
		quote:
			"Transformed our corporate headquarters into a modern, functional space that our employees love.",
		name: "Ahmed Hassan",
		title: "VP Operations, Batelco",
	},
	{
		quote:
			"Professional, creative, and delivered beyond our expectations. Highly recommended for luxury projects.",
		name: "Maria Santos",
		title: "Property Manager, Investcorp",
	},
	{
		quote:
			"The blend of Bahraini culture with contemporary design created a truly unique banking environment.",
		name: "Jean-Pierre Dubois",
		title: "Regional Director, BNP Paribas",
	},
	{
		quote:
			"Outstanding attention to accessibility and safety standards while maintaining aesthetic excellence.",
		name: "Khalid Al-Mahmood",
		title: "Safety Coordinator, ABS",
	},
	{
		quote:
			"Brought innovative solutions to our educational spaces that enhanced the learning environment.",
		name: "Fatima Al-Doseri",
		title: "Facilities Head, BAISP",
	},
	{
		quote:
			"Delivered a hospitality project that set new standards for luxury in the region.",
		name: "Mohamed Al-Zayani",
		title: "Development Manager, ZGH",
	},
];

export default testimonials;
